import { useEffect } from "react"

/*
binds event callbacks that have state dependent inputs.
Whenever the callback changes the event gets re-bound
 */
type EventHandler<T> = (event: string, callback: (e: T) => void) => void
export const useEventBind = <E>(
  ref:
    | {
        addEventListener: EventHandler<E>
        removeEventListener: EventHandler<E>
      }
    | undefined
    | null,
  event: string,
  callback: (e: E) => void,
) => {
  useEffect(() => {
    ref?.addEventListener(event, callback)
    return () => {
      ref?.removeEventListener(event, callback)
    }
  }, [callback])
}
